/* LAUVEE - Abonnement tete de rechange (Shopify Subscriptions).
   Va avec snippets/lauvee-subscription.liquid.

   - Fiche de la tete ("picker") : choix Abonnement / Achat unique. En
     abonnement, la ligne part au panier avec le selling_plan de l'offre et le
     prix du bouton passe au prix abonne.
   - Fiche de la brosse L1 ("addon") : case a cocher. Cochee, on ajoute en
     plus la tete de la meme couleur, avec le selling_plan.

   L'ajout lui-meme reste fait par assets/lauvee-refonte.js : il appelle
   window.lvSubscription.items() et envoie les lignes renvoyees (ou l'ajout
   simple habituel si la fonction renvoie null). */
(function () {
  'use strict';

  function normalize(value) {
    return String(value).normalize('NFC').trim().toLowerCase();
  }

  function readVariants(root) {
    var script = root.querySelector('[data-lv-sub-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  /* Couleur choisie sur la fiche (les deux produits n'ont qu'une option). */
  function selectedValues(productInfo) {
    var values = [];
    productInfo.querySelectorAll('fieldset.product-form__input input[type="radio"]:checked').forEach(function (radio) {
      values.push(normalize(radio.value));
    });
    return values;
  }

  function headVariant(root, productInfo) {
    var variants = readVariants(root);
    var values = selectedValues(productInfo);
    var match = null;

    variants.forEach(function (variant) {
      if (!match && variant.available && values.indexOf(normalize(variant.title)) !== -1) match = variant;
    });
    if (match) return match;

    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }
    return null;
  }

  function isActive(root) {
    if (root.dataset.lvSub === 'picker') {
      var checked = root.querySelector('input[name="lv-purchase"]:checked');
      return !checked || checked.value === 'sub';
    }
    var box = root.querySelector('[data-lv-sub-addon]');
    return !!(box && box.checked);
  }

  function setText(root, selector, text) {
    var el = root.querySelector(selector);
    if (el && text && el.textContent !== text) el.textContent = text;
  }

  function refresh(root) {
    var productInfo = root.closest('product-info') || document;
    var variant = headVariant(root, productInfo);
    var active = isActive(root);

    if (variant) {
      setText(root, '[data-lv-sub-compare]', variant.price);
      setText(root, '[data-lv-sub-price]', variant.sub);
      setText(root, '[data-lv-sub-once]', variant.price);
    }

    root.classList.toggle('is-active', active);
    if (productInfo.classList) productInfo.classList.toggle('lv-sub-on', active);

    /* Fiche de la tete : le bouton affiche le prix de la formule choisie.
       lauvee-pdp.js relit cet attribut a chaque redecoration du bouton. */
    if (root.dataset.lvSub === 'picker' && variant) {
      var price = active ? variant.sub : variant.price;
      root.setAttribute('data-lv-sub-override', price);
      productInfo.querySelectorAll('.product-form__submit [data-lv-btn-price]').forEach(function (el) {
        if (el.textContent.trim() !== price) el.textContent = price;
      });
    }
  }

  function init(root) {
    if (root.dataset.lvSubReady) return;
    root.dataset.lvSubReady = '1';

    root.addEventListener('change', function () {
      refresh(root);
    });

    var productInfo = root.closest('product-info');
    if (productInfo) {
      productInfo.addEventListener('change', function (event) {
        if (event.target.closest && event.target.closest('fieldset.product-form__input')) {
          setTimeout(function () {
            refresh(root);
          }, 60);
        }
      });
    }

    refresh(root);
  }

  window.lvSubscription = {
    /* Lignes a envoyer a /cart/add.js, ou null pour l'ajout simple. */
    items: function (productInfo, variantId, quantity) {
      var root = productInfo.querySelector('[data-lv-sub]');
      if (!root || !isActive(root)) return null;

      var plan = parseInt(root.dataset.plan, 10);
      if (!plan) return null;

      if (root.dataset.lvSub === 'picker') {
        return [{ id: parseInt(variantId, 10), quantity: quantity, selling_plan: plan }];
      }

      var head = headVariant(root, productInfo);
      if (!head) return null;

      return [
        { id: parseInt(variantId, 10), quantity: quantity },
        { id: head.id, quantity: 1, selling_plan: plan }
      ];
    }
  };

  function start() {
    document.querySelectorAll('[data-lv-sub]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
